import * as React from 'react'

import { Table, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type FiltersForm from 'modules/core/lib/forms/Filters'
import i18n from 'modules/core/lib/i18n'

import SortableHeader from './SortableHeader'

interface Props {
  filtersForm: FiltersForm
}

const Header = ({ filtersForm }: Props) => {
  return (
    <Table.Head>
      <Table.Row>
        <SortableHeader filtersForm={filtersForm} attribute="full_name">
          <Text size="200" color="grey800" weight="semibold">
            {i18n.t('payroll_bundle.payroll_issues.issues')}
          </Text>{' '}
        </SortableHeader>
      </Table.Row>
    </Table.Head>
  )
}

export default observer(Header)
